"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _FilledInput = _interopRequireDefault(require("../FilledInput"));
var _MD = _interopRequireDefault(require("../Icons/CaretDown/MD"));
var _tss = require("../styles/tss");
var _SelectInput = _interopRequireDefault(require("./SelectInput"));
var _SelectInputNative = _interopRequireDefault(require("./SelectInputNative"));
const _excluded = ["autoWidth", "children", "displayEmpty", "IconComponent", "id", "isSsrOnly", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsSelect',
  uniqId: 'q7eO89'
})((theme, _params, classes) => {
  const spacing = theme.busbud.spacing;
  return {
    root: {},
    select: {
      appearance: 'none',
      MozAppearance: 'none',
      // Reset
      WebkitAppearance: 'none',
      // Reset
      userSelect: 'none',
      borderRadius: 0,
      minWidth: spacing(10),
      // So it doesn't collapse.
      cursor: 'pointer',
      paddingRight: spacing(4),
      '&::-ms-expand': {
        display: 'none'
      },
      [`&.${classes.disabled}`]: {
        cursor: 'default'
      },
      [`&.${classes.multiple}`]: {
        height: 'auto'
      }
    },
    selectMenu: {
      height: 'auto',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    disabled: {},
    error: {},
    focused: {},
    multiple: {},
    icon: {
      position: 'absolute',
      right: spacing(1.5),
      [`&.${classes.sizeSm}`]: {
        right: spacing(1)
      },
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      color: theme.busbud.colors.component.textfield.normal.icon,
      [`&.${classes.focused}`]: {
        color: theme.busbud.colors.component.textfield.focused.icon
      },
      [`&.${classes.disabled}`]: {
        color: theme.busbud.colors.component.textfield.disabled.icon
      },
      [`&.${classes.error}`]: {
        color: theme.busbud.colors.component.textfield.error.icon
      }
    },
    iconOpen: {
      transform: 'translateY(-50%) rotate(180deg)'
    },
    sizeMd: {},
    sizeSm: {}
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Select` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-select-select):
 *
 * ```tsx
 * import { Select } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-select--page)
 */
const Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
  const {
      autoWidth = false,
      children,
      displayEmpty = false,
      IconComponent = _MD.default,
      id,
      isSsrOnly = false,
      input,
      inputProps,
      label,
      labelId,
      MenuProps,
      multiple = false,
      native = false,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes
  } = useStyles(undefined, {
    props: {
      classes: inputProps?.classes
    }
  });
  const inputComponent = native ? _SelectInputNative.default : _SelectInput.default;
  const InputComponent = input || /*#__PURE__*/React.createElement(_FilledInput.default, null);
  const InputIconComponent = props.disabled || props.readOnly ? undefined : IconComponent;
  return /*#__PURE__*/React.cloneElement(InputComponent, _objectSpread({
    inputComponent,
    inputProps: _objectSpread(_objectSpread(_objectSpread({
      children,
      IconComponent: InputIconComponent,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple
    }, native ? {
      id
    } : {
      autoWidth,
      displayEmpty,
      isSsrOnly,
      labelId,
      MenuProps,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps: _objectSpread({
        id
      }, SelectDisplayProps)
    }), inputProps), {}, {
      classes
    }, input ? input.props.inputProps : {}),
    ref
  }, other));
});
var _default = exports.default = Select;